<template>
  <v-card id="event-info-modal"  :style="'padding: 0;'+(hideBoxShadow?' box-shadow:none!important':'')" :loading="isLoading" tile>
    
    <div style="padding: 10px; float: right;"  v-if="evento.creatore != null && !isMobile">
      <span>
        <v-avatar
          :color="
            evento.creatore.color != null ? evento.creatore.color : '#777'
          "
          size="26"
          ><v-icon dark> mdi-account-circle </v-icon>
        </v-avatar>
        {{ this.evento.creatore.username }}
      </span>
    </div>
    <v-card-title
    v-if="!hideEventDescription"
      style="padding: 10px; min-height: 52px; text-transform: uppercase;overflow:hidden;white-space: nowrap;
    font-weight: 400;;"
    >
      {{ this.evento.descrizione }}
    </v-card-title>
    <v-card-text style="padding: 0" v-if="evento.tipo == EventType.Assenza">
      <v-card flat>
        <v-card-text>
          <TabDatiEvento v-bind:evento="this.evento"></TabDatiEvento>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-text style="padding: 0" v-if="evento.tipo != EventType.Assenza">
      <v-tabs v-model="activeTab"
      center-active 
      right
      color="red"
      show-arrows 
      style="height=100%"
      >
        <v-tab key="k1" href="#k1"><v-icon>mdi-calendar</v-icon><span v-if="!isMobile"> Dati Evento </span></v-tab>
        <v-tab key="k2" href="#k2"><v-icon>mdi-account-multiple</v-icon><span v-if="!isMobile"> Operatori </span></v-tab>
        <v-tab key="k3" href="#k3"><v-icon>mdi-car</v-icon><span v-if="!isMobile"> Mezzi </span></v-tab>
        <v-tab key="k4" href="#k4"><v-icon>mdi-tools</v-icon><span v-if="!isMobile">  Attrezzature </span></v-tab>

        <v-tab-item key="k1" value="k1">
          <v-card flat>
            <v-card-text>
              <TabDatiEvento v-bind:evento="this.evento"></TabDatiEvento>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item key="k2" value="k2">
          <v-card flat>
            <v-card-text>
              <TableRisorse
                v-bind:evento="this.evento"
                resources-type="Uomo"
              ></TableRisorse>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item key="k3" value="k3">
          <v-card flat>
            <v-card-text>
              <TableRisorse
                v-bind:evento="this.evento"
                resources-type="Mezzo"
              ></TableRisorse>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item key="k4" value="k4">
          <v-card flat>
            <v-card-text>
              <TableRisorse
                v-bind:evento="this.evento"
                resources-type="Attrezzatura"
              ></TableRisorse>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card-text>
  </v-card>
</template>
<style scoped>
.mainPage[isMobile="true"] .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none !important;
}

</style>
<script>
import EventType from "../../settings/EventType";
import EasyPlanClient from "../../utils/EasyPlanClient";
import TabDatiEvento from "./Tabs/TabDatiEvento";
import TableRisorse from "./Tabs/TableRisorse";

export default {
  props: {evento:{default:null},
  hideEventDescription:{default:false,type:Boolean},
  hideBoxShadow:{default:false,type:Boolean},
  
  },
  components: {
    TabDatiEvento,
    TableRisorse,
  },
  data: () => ({
    EventType: EventType,
    isMobile:false,
    isLoading:false,
    activeTab: "k1",
  }),
  mounted() {
    this.loadEventData(this.event);
    this.setDefaultTab();
    
  },

  created() {
    this.checkIfIsMobile();
    // this.loadEvents();
  },
  methods: {
     checkIfIsMobile() {
      this.isMobile= window.innerWidth < 600;
    },
    async loadEventData(event) {
      this.isLoading = true;
    if(event!=undefined&& event!=null)
      if (this.evento.creatore == null) {
        let creator = await this.loadUser(event.idCreatore);
        this.evento.creatore = creator;
        this.refresh();
      }
      this.isLoading = false;
    },
    setDefaultTab() {
      this.activeTab = "k1";
    },

    refresh() {
      let ev = this.evento;
      this.evento = ev;
    },
    async loadUser(userId) {
      let res = null;
      try {
        console.log("loading user", userId);
        res = await EasyPlanClient.User.Find(
          this.$route.params.companyAlias,
          userId
        );

        console.debug("user loaded", res);
        // callback(res.data.data);

        return res.data.data;
      } catch (error) {
        this.handleError(error);
      }
      return null;
    },
    handleError(error) {
      console.log(error);
      this.error = EasyPlanClient.GetErrorDescription(
        error.response.data.errorCode
      );
      console.error(
        "si è verificato un errore (" +
          error.response.data.errorCode +
          ")" +
          this.error
      );
    },
  },
  watch: {
    evento(value, old) {
      this.setDefaultTab();
      this.loadEventData(value);
    },
  },
  // methods: {
  //   loadEvents(eventId) {
  //     console.log("loading workers...");
  //     EasyPlanClient.Event.Find(this.$route.params.companyAlias,eventId)
  //       .then((res) => {
  //         this.event = res.data.data;
  //         console.log(this.events);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         this.error = EasyPlanClient.GetErrorDescription(
  //           error.response.data.errorCode
  //         );
  //         console.error(
  //           "si è verificato un errore (" +
  //             error.response.data.errorCode +
  //             ")" +
  //             this.error
  //         );
  //         console.error(error);
  //       });
  //   },
  // },
};
</script>

